<div class="container">
  <!-- Error Notification (Top Right) -->
  <div *ngIf="errorMessage" class="error-notification">
    <svg class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="error-notification-message">{{ errorMessage }}</span>
  </div>
  <div class="d-flex justify-content-between align-items-center mt-4 mb-4">
    <h2>Product Management</h2>
    <button class="btn btn-primary" (click)="showAddForm = true">Add Product</button>
  </div>

  <div class="card mb-4" *ngIf="showAddForm">
    <div class="card-body">
      <h4>{{ editingProduct ? 'Edit' : 'Add' }} Product</h4>
      <form (ngSubmit)="saveProduct()">
        <div class="form-group">
          <label>Product Name</label>
          <input type="text" class="form-control" [(ngModel)]="productForm.name" name="name" required>
        </div>
        <div class="form-group">
          <label>Category</label>
          <select class="form-control" [(ngModel)]="productForm.category" name="category" required>
            <option value="">Select Category</option>
            <option *ngFor="let cat of categories" [value]="cat._id">{{ cat.name }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" [(ngModel)]="productForm.description" name="description" rows="3"></textarea>
        </div>
        <div class="form-group">
          <label>Unit</label>
          <input type="text" class="form-control" [(ngModel)]="productForm.unit" name="unit" placeholder="e.g., kg, pcs, liters">
        </div>
        <button type="submit" class="btn btn-success me-2">Save</button>
        <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
      </form>
    </div>
  </div>

  <div class="card">
    <div class="card-body">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Description</th>
            <th>Unit</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of products">
            <td>{{ product.name }}</td>
            <td>{{ product.category?.name }}</td>
            <td>{{ product.description }}</td>
            <td>{{ product.unit }}</td>
            <td>
              <button class="btn btn-sm btn-primary me-2" (click)="editProduct(product)">Edit</button>
              <button class="btn btn-sm btn-danger" (click)="deleteProduct(product._id)">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

